<div class="d-flex justify-content-end pt-4 pb-3">
    <button class="full-width mx-2" mat-raised-button (click)="closeFormEmit()"
            matTooltip="Zamknij formularz" matTooltipPosition="below">
        <i class="fa-solid fa-rotate-left"></i> Anuluj
    </button>
    <button class="full-width mx-2" mat-raised-button color="warn" (click)="saveEmit()"
            matTooltip="Zapisz dane" matTooltipPosition="below" [disabled]="invalid">
        <ng-container *ngIf="!addMode else add">
            Zapisz <i class="fa-solid fa-floppy-disk"></i>
        </ng-container>
        <ng-template #add>
            Dodaj <i class="fa-solid fa-plus"></i>
        </ng-template>
    </button>
</div>
